// extracted by extract-css-chunks-webpack-plugin
module.exports = {"swiper_box":"swiper_box-n-v9IN1q","swiper":"swiper-18zId8II","swiper_item":"swiper_item-2OI-VVnY"};